import { ResponsiveValue } from "styled-system";

interface DividerProps {
  width?: ResponsiveValue<string | number>;
  className?: string;
}

const Divider = ({ width, className }: DividerProps) => {
  return (
    <div
      className={className}
      sx={{
        width: width ? width : ["80vw"],
        maxWidth: "1366px",
        backgroundColor: "brand.black",
        height: 1,
        my: "30px",
      }}
    ></div>
  );
};

export default Divider;
